var React = require('react');

function ArrowWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.3249 3.70947L9.1475 0.964098C8.99185 0.829608 8.99185 0.610672 9.1475 0.476182L9.58189 0.100867C9.73755 -0.0336225 9.99094 -0.0336225 10.1466 0.100867L14.7439 4.073C14.8225 4.14096 14.8614 4.23049 14.8606 4.31979C14.8614 4.40908 14.8225 4.4986 14.7439 4.56655L10.1466 8.5383C9.99094 8.67278 9.73755 8.67278 9.58189 8.5383L9.1475 8.16302C8.99185 8.02855 8.99185 7.80963 9.1475 7.67516L12.3265 4.92871H0.398181C0.177367 4.92871 0 4.77552 0 4.58482V4.05336C0 3.86266 0.177367 3.70947 0.398181 3.70947H12.3249Z","fill":"#FFFFFF"}));
}

ArrowWhite.defaultProps = {"width":"15","height":"9","viewBox":"0 0 15 9","fill":"none"};

module.exports = ArrowWhite;

ArrowWhite.default = ArrowWhite;
